import React from 'react';
import {useAppSelector} from "@Hooks/selector/useAppSelector";
import {PagesType} from "@/types/pageSlice/Pages.type";
import UrlObjectType from "@/types/pageSlice/UrlObject.type";
import MenuItem from "@Header/components/TopBar/MenuItem";
import {localeSpecificMenuItems} from "@Header/constants/localeSpecificMenuItems";
import useCompanyStyle from "@Hooks/selector/useCompanyStyle";
import useCreateCompanySpecificMenuItems from "@Header/hooks/useCreateCompanySpecificMenuItems";
import {useIsAircash} from "@Hooks/selector/useIsAircash";
import TransportSpecificLinksTitle from "@Header/components/TransportSpecificLinks/TransportSpecificLinksTitle";
import {useHandleMainMenu} from "@Header/hooks/useHandleMainMenu";
import ClickOutsideAwareComponent from "@Features/clickOutsideAwareComponent/components/ClickOutsideAwareComponent";
import Translation from "@Translation/components/Translation";
import IconChevron from "@Icons/chevrons/IconChevron";
import {Colors} from "@Styles/Colors.style";
import {LocaleSpecificMainMenuItem} from "@Header/components/TopBar/LocaleSpecificMainMenuItem";

function LocaleSpecificMainMenu({topBarRef}: { topBarRef: React.RefObject<HTMLDivElement> }) {
    const {currentRoute} = window
    const urlsObject = useAppSelector((state) => state?.page.urlsObject)
    const urlsForHeaderMenu = useAppSelector((state) => state?.page.urlsForHeaderMenu)
    const genericMenuItems = [];
    const {company_id: companyId, id: storeId} = useCompanyStyle()
    const isAircash = useIsAircash()

    // Filter out stationLocator and blog for Aircash stores
    const filteredMenuItems = isAircash
        ? localeSpecificMenuItems.filter((item) => !['stationLocator', 'blog'].includes(item))
        : localeSpecificMenuItems

    filteredMenuItems.map((item) => {
        const menuItem = Object.entries(urlsObject).find((entry : [PagesType, UrlObjectType]) => {
            const [key, urlObject] = entry
            return key === item
        })

        if (menuItem && menuItem[1].text !== "") {
            genericMenuItems.push(menuItem)
        }
    })

    const companySpecificMenuItems = useCreateCompanySpecificMenuItems({urlsForHeaderMenu, companyId, storeId})

    const menuItems = [...companySpecificMenuItems, ...genericMenuItems]

    const {
        visibleMenuList,
        moreMenuList,
        showDropdown,
        toggleDropdown,
        setDropdown,
    } = useHandleMainMenu(topBarRef, menuItems)

    return (
        <>
            {visibleMenuList.map((entry) => (
                <LocaleSpecificMainMenuItem
                    entry={entry}
                    currentRoute={currentRoute}
                />
            ))}
            {moreMenuList.length > 0 && (
                <ClickOutsideAwareComponent onClickOutside={() => setDropdown(false)}>
                    <ul className="gb--menu__item">
                        <li>
                            <span
                                onClick={toggleDropdown()}
                            >
                                <Translation translationKey="sys.more"/>
                                <IconChevron height="16" fill={Colors.neutralWhiteColor}/>
                            </span>
                            <ul className={`select__list ${showDropdown ? 'select__list--opened' : ''}`}>
                                {moreMenuList.map((entry) => (
                                    <LocaleSpecificMainMenuItem
                                        entry={entry}
                                        currentRoute={currentRoute}
                                    />
                                ))}
                            </ul>
                        </li>
                    </ul>
                </ClickOutsideAwareComponent>
            )}
        </>
    )
}

export default LocaleSpecificMainMenu